import template from './template.html';

controller.$inject = ['$filter', 'FileSaver', 'Blob', 'ShiftsService'];

export function controller($filter, FileSaver, Blob, ShiftsService) {
    const vm = this;
    vm.exportData = exportData;
    vm.name = (vm.filename || 'export') + '.csv';

    function exportData() {
        ShiftsService.downloadShifts(vm.week).then(shifts => {
            const data = formatData(shifts);
            const blob = new Blob([data], {
                type: 'data:text/csv;charset=utf-8'
            });

            FileSaver.saveAs(blob, vm.name);
        });
    }

    function formatData(data) {
        if (!data || data.constructor !== Array) return;

        let shifts = data.map(formatShift);
        return shifts.join('\n');
    }

    function formatShift(shift) {
        const date = new Date(shift.date);

        const s = {
            store: shift.storeId,
            date: $filter('date')(date, 'dd/MM/yyyy', 'UTC'),
            start: padNumber(shift.start, 4, '0'),
            end: padNumber(shift.end, 4, '0'),
            type: shift.type
        };

        return `${s.store},${s.date},${s.start},${s.end},${s.type}`;
    }

    function padNumber(number, requiredLength, paddingCharacter) {
        requiredLength = parseInt(requiredLength);
        if (number.length >= requiredLength) return number;

        let result = number.toString();
        while (result.length < requiredLength) {
            result = paddingCharacter + result;
        }
        return result;
    }
}

export default () => ({
    template: template,
    controller: controller,
    restrict: 'EA',
    controllerAs: 'vm',
    bindToController: {
        week: '=',
        filename: '='
    },
    scope: {}
});



// WEBPACK FOOTER //
// ./src/js/components/common/exportbutton/index.js